module.exports = __webpack_public_path__ + "media/instavid.ff58d8bf.mp4";